module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("g8Jyh"))).then(() => parcelRequire('8OwZp'));